<template>
  <vx-card title="Filter Inventory" class="mb-6">
    <form data-vv-scope="Inventory" class="">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex flex-wrap focusHolder">
          <!--   <vs-input
              label="Category"
              class="mb-4 w-1/2 p-2"
              v-model="filter.category"
            /> -->
            <div class="sm:w-1/2 w-full p-1">
              <label class="vs-input--label w-full">Category List</label>
              <v-select
              class="w-full"
              label="category_name"
              v-validate="'required'"
              :reduce="(option) => option.assets_categories_id"
              :options="categoryList"
              v-model="filter.assets_categories_id"
              :clearable="false"
              data-vv-name="Category Name"
              name="Category Name"
              >
              </v-select>
            </div>
            <div class="sm:w-1/2 w-full p-1">
              <label class="vs-input--label w-full">Inventory</label>
              <v-select
                class="w-full"
                :options="inventoryTypeList"
                label="name"
                v-model="filter.inventory_id"
                :reduce="(item) => item.assets_id"

              ></v-select>
            </div>
            <div class="sm:w-1/2 w-full p-1">
             <label class="vs-input--label w-full">Inventory Type</label>
             <v-select
              class="w-full"
              label="name"
              v-validate="'required'"
              :reduce="(option) => option.id"
              :options="inventory_type_array"
              v-model="filter.inventory_type"
              :clearable="false"
              data-vv-name="Inventory Type"
              name="Inventory Type"
              >
              </v-select>
            </div>
            <div class="sm:w-1/2 w-full p-1">
              <vs-input
                label="Suitable For"
                class="w-full"
                v-model="filter.tags"
              />
            </div>
            <div class="sm:w-1/2 w-full p-1">
              <vs-input
                class="w-full"
                v-model="filter.price"
                label="Inventory Price"
              />
            </div>
          </div>
        </div>


      </div>
        <div class="flex mt-2 justify-end">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-search"
            class="mr-2"
            @click="filterInventory()"
          >
          </vs-button>
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-refresh-ccw"
            @click="resetFilterRoom()"
          >
          </vs-button>
        </div>
    </form>
  </vx-card>
</template>
<script>
import vSelect from 'vue-select'
import { roomInventory } from '@/mixins/Rooms/roomInventory.js'
export default {
  components: {
    vSelect
  },

  mixins: [roomInventory],
  data () {
    return {
      inventory_type_array:[
        {
          id:'0',
          name: 'Removal'
        },
        {
          id:'1',
          name: 'Non-Removal'
        }
      ],
      asset_types: 'Room',
      assets_id: null,
      category_id: '',
      filter: {
        assets_categories_id:'',
        asset_details: '',
        name: '',
        inventory_type: '',
        inventory_details: '',
        inventory_id: '',
        tags: '',
        price: ''
      }
    }
  },
  created () {
    this.fetchingAssetsCategory()
    this.fetchingInventoryType()
  },
  methods: {
    resetFilterRoom () {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = ''
      })
      this.$emit('resetFilter')

    },
    filterInventory () {
      const newArray = Object.keys(this.filter)
      const fiteredArray = newArray.filter((ele) => {

        return this.filter[ele]
      })
      if (fiteredArray.length) {
        this.$emit('filterObject', this.filter)
      } else {
        this.showSuccessMessage(
          'Error',
          'Atleast filter by one value',
          'danger'
        )
      }

      //   newArray.filter(ele,index=>ele.1!false)


    }
  }
}
</script>
